import axiosInstance from "./axios/axios_instance"
const http = axiosInstance("/protected",  null, "/logout")

const GetUsers = (limit, offset, body) =>
    http.post(`/get_users//${limit}/${offset}`, body)
const GetUser = (email) => http.post(`/get_users/${email}`)
const PutUser = (email, body) => http.put(`/user/${email}`, body)
const DeleteUser = (email) => http.delete(`/user/${email}`)
const GetAccessCodes = (limit, offset, usable, expired, used, search) =>
    http.get(`/access_codes/null/${limit}/${offset}/${usable}/${expired}/${used}/${search ? search : ""}`)
const DeleteAccessCode = (id) => http.delete(`/access_codes/${id}`)
const PostAccessCode = (body) => http.post(`/access_codes`, body)
const PostSubscription = (body) => http.post("/subscription", body)
const GetAccreditation = (email) =>
    http.get(`/accreditation/${email}`)
const GetAccreditations = (limit, offset, order = "desc") =>
    http.get(`/accreditation//${limit}/${offset}?order=${order}`)
const VerifyAccreditation = (accreditation_id) =>
    http.put(`/verify_accreditation/${accreditation_id}`)
const declineAccreditation = (accreditation_id) =>
    http.put(`/decline_accreditation/${accreditation_id}`)
const DownloadAccreditationFile = (email) => http.get(`/accreditation_file/${email}`)
const GetNotes = (user_email) =>
    http.get(`/user_notes/${user_email}`)
const AddNote = (user_email, body) =>
    http.post(`/user_notes/${user_email}`, body)
const RemoveSubscription = (user_email) =>
    http.delete(`/subscription/${user_email}`)

export default {
    GetUsers,
    GetUser,
    GetAccessCodes,
    DeleteAccessCode,
    PostAccessCode,
    PostSubscription,
    PutUser,
    DeleteUser,
    GetAccreditation,
    GetAccreditations,
    VerifyAccreditation,
    declineAccreditation,
    DownloadAccreditationFile,
    GetNotes,
    AddNote,
    RemoveSubscription
}